import { css } from '@emotion/react';
import type { Theme } from '~/_shared/themes/theme.model';

export const formStyle = css({
  display: 'flex',
  flexDirection: 'column',
  gap: 8,
  padding: 16,
});

export const settingStyle = css({
  display: 'flex',
  flexDirection: 'column',
  fontSize: 14,
  gap: 4,
});

export const labelStyle = css({
  fontSize: 14,
  textTransform: 'uppercase',
});

export const buttonStyle = css({
  fontSize: 14,
  marginTop: 8,
  width: '100%',
});

export const alertStyle = css({
  marginTop: 8,
});

export const dropdownTriggerStyle = ({ isPlaceholder }: { isPlaceholder: boolean }) => (theme: Theme) => css({
  color: isPlaceholder ? theme.textColors.disabled : undefined,
  height: 40,
});

export const dataLayersOptionStyle = css({
  display: 'flex',
  alignItems: 'center',
  padding: '4px 0',
  width: '100%',
});

export const dataLayersCheckboxStyle = (theme: Theme) => css({
  textTransform: 'uppercase',
  color: theme.textColors.secondary,
  fontSize: '12px',
});
